import ru from './ru.json';
import en from './en.json';

export default {
  en,
  ru,
};

export function getDefaultI18nMessage(id, language) {
  switch (language) {
    case 'en':
      return en[id] || id;
    default:
      return ru[id] || id;
  }
}

export function computeFormatMessage(id, ...rest) {
  return { id, defaultMessage: getDefaultI18nMessage(id), ...rest };
}
